<template>
  <section id="Summary">
    <b-container>
      <b-row id="summary-content">
        <b-col lg="6" md="12" class="renewList">
          <div>
            <h1 class="section-title">{{ pageTitle }}</h1>
            <div class="line"></div>
          </div>
          <p v-html="pageCopy"></p>
          <div class="attachment-button">
            <div class="buy-now">
              <b-button
                :href="
                  'https://rays.fanportal-mlb.com/2024tickets/upload/' +
                  pageAttachment
                "
                :download="pageAttachmentTitle"
                target="_blank"
                class="btn btn-secondary"
              >
                {{ pageAttachmentTitle }}
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col lg="6" md="12" class="player">
          <img
            :src="
              'https://rays.fanportal-mlb.com/2024tickets/upload/' + pageImg
            "
            alt="Player"
          />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Summary",
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      pageTitle: this.$store.state.epitch.getSummary[0].title,
      pageCopy: this.$store.state.epitch.getSummary[0].copy,
      pageImg: this.$store.state.epitch.getSummary[0].image,
      pageAttachment: this.$store.state.epitch.getSummary[0].attachment,
      pageAttachmentTitle:
        this.$store.state.epitch.getSummary[0].attachmentTitle,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
#Summary {
  margin: auto;
  padding: 150px 0 100px;
  background-image: url("~@/assets/images/welcome/bgImage_gray.jpg");
  background-size: cover;
  @media only screen and (max-width: $md) {
    padding-block: 50px;
  }
  h1 {
    font-family: "Antique Olive";
    font-style: normal;
    font-weight: 700;
    font-size: 35px;
    text-transform: uppercase;
    color: #00285e;

    @media only screen and (max-width: $sm) {
      line-height: 1;
      font-size: 25px;
    }
  }
  p {
    margin: 10px 0;
  }
  .buy-now {
    width: 100%;
    margin: 20px 0;
    a {
      width: 100%;
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      text-transform: uppercase;
      color: #00285e;
      border: 2px solid #00285e;
      border-radius: 50px;
      padding: 10px 40px;
      background: transparent;
    }
  }
}
</style>
